<template>
  <div style="width: 100%; text-align:right;">
    <v-layout row wrap style="padding: 10px;">
      <!--<v-flex xs4>
        סינון שלב התקדמות
        <span class="custom-dropdown custom-dropdown--white" style="float: right;">
          <select v-model="selectedReport" class="custom-dropdown__select custom-dropdown__select--white">
            <option value="">הצג הכל</option>
            <option v-for="rpt in reports" :value="rpt">{{rpt}}</option>
          </select>
        </span>
      </v-flex>-->
      <v-flex xs10>
        &nbsp;
      </v-flex>
      <v-flex xs2>
        <v-icon class="btnIcon mr-2 ml-2 left" v-tooltip:bottom="{ html: 'הדפסה' }">print</v-icon>
        <v-icon class="btnIcon mr-2 ml-2 left" v-tooltip:bottom="{ html: 'ייצוא אקסל' }">file_download</v-icon>
      </v-flex>
    </v-layout>
    <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
      <tr class="trPrint trHeader">
        <th class="tdData sp">שם לקוח/רוכש</th>
        <th class="tdData">איש קשר</th>
        <th class="tdData">טלפון</th>
        <th class="tdData">חשבון משתמש</th>
        <th class="tdData">יומנים שנרכשו</th>
        <th class="tdData">יומנים בשימוש</th>
        <!--<th class="tdCtrl" style="width: 160px!important;"></th>-->
      </tr>
    </table>
    <div class="scrollContent" v-if="hasData">
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
        <tr v-for="row in filteredRows">
          <td class="tdData sp">{{row.FullName}}</td>
          <td class="tdData tdTxt">{{row.ContactPerson}}</td>
          <td class="tdData tdTxt">{{row.Phone}}</td>
          <td class="tdData tdTxt">{{row.Username}}</td>
          <td class="tdData tdTxt">{{row.TotalDiaries}}</td>
          <td class="tdData tdTxt">{{row.UsedDiaries}}</td>
          <!--<td class="tdCtrl tdTxt" style="width: 160px!important;">
            <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
            <v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
          </td>-->
        </tr>
      </table>
    </div>
    <div fluid v-else>
      <h3 style="padding-top: 40px;">אין נתונים</h3>
    </div>
  </div>
</template>

<script>
  import { db } from '../firebase';
  var usersRef = db.ref('Users');

  export default {
    name: 'ReportCustomers',
    data() {
      return {
      }
    },
    firebase: function () {
      var vm = this;
      return {
        users: usersRef.orderByChild("Type").equalTo("רוכש")
      }
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      filteredRows() {
        var vm = this;
        if (vm.$parent.txtSearch.length > 0) {
          var result = [];
          try {
            var rowsCount = 0;
            result = vm.users.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                  rowsCount++;
                  return row;
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          var result = vm.users;
        }

        return result;
      }
    },
    created() {
      this.$Log("Vue [ReportCustomers] is created ...");
    },
    ready() {
      this.$Log("Vue [ReportCustomers] is ready ...");
    },
    mounted() {
      this.$Log("Vue [ReportCustomers] is mounted ...");
    },
    updated() {
      this.$Log("Vue [ReportCustomers] is updated ...");
    },
    methods: {
      getStatusColor(statusKey) {
        var selectedColor = '#F7941D';
        for (var i = 0; i < this.statuses.length; i++) {
          if (this.statuses[i]['.key'] == statusKey) {
            selectedColor = this.statuses[i].Color;
            break;
          }
        }
        return selectedColor;
      },
      getStatusName(statusKey) {
        var selectedName = '';
        for (var i = 0; i < this.statuses.length; i++) {
          if (this.statuses[i]['.key'] == statusKey) {
            selectedName = this.statuses[i].Name;
            break;
          }
        }
        return selectedName;
      },
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// ReportCustomers.vue?2a9c17cf